const FooterBackgroundLeft_SVG = (props) => {
	return (
			<svg width="81" height="507" viewBox="0 0 81 507" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
				<path opacity="0.7"
				      d="M61.2122 0V10.1489H40.8081V20.2979H20.4041V30.4468H10.202V50.7447H0V455.404H10.202V475.702H20.4041V485.851H40.8081V496H61.2122V506.149V0Z"
				      fill="#002432"/>
				<path d="M80.2122 0V10.1489H59.8081V20.2979H39.4041V30.4468H29.202V50.7447H19V455.404H29.202V475.702H39.4041V485.851H59.8081V496H80.2122V506.149V0Z"
				      fill="#685552"/>
			</svg>
)
}
export default FooterBackgroundLeft_SVG;

export const FooterBackgroundRight_SVG = (props) => {
	return (
			<svg width="62" height="505" viewBox="0 0 62 507" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
				<path d="M51.01 50.7447V30.4468H40.8099V20.2979H20.3999V10.1489H0V0V506.149V496H20.3999V485.851H40.8099V475.702H51.01V455.404H61.21V50.7447H51.01Z"
				      fill="#685552"/>
			</svg>

	)
}

